export default __webpack_public_path__ + "static/media/wateringcan 1.39ac4a90.png";